export const PLAN_CARD_PRICE_ROW_MIN_H = '63px';
export const PLAN_CARD_PRICE_BLOCK_MIN_H = '86px';

export const PLAN_CARD_GRADIENT_BORDER = {
  content: '""',
  position: 'absolute',
  inset: 0,
  padding: '2px',
  borderRadius: 'inherit',
  background: 'linear-gradient(180deg, #FF9554 16%, #FF4935 100%)',
  WebkitMask:
    'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
  WebkitMaskComposite: 'xor',
  maskComposite: 'exclude',
  pointerEvents: 'none',
};

export const PLAN_CARD_BORDER = {
  border: '1.5px solid',
  borderColor: 'lightGrey',
};
